import { Badge } from "@/modern/components/ui/badge";
import { Loader2, Upload } from "lucide-react";
import { EntityFileProvider, useEntityFileContext, CompanyCamButton, FileMenu, FileSliderView } from "@/react/components/entityViews/files";
import { useRef } from "react";
import { FileDetailModal } from "@/react/components/entityViews/files/components/editors/FileDetailModal";
import { useEntityManagerContext } from "../context/EntityManagerContext";

export function EntityManagerFileBar() {
  const { record, entityType } = useEntityManagerContext();
  return (
    <EntityFileProvider record={record} entityType={entityType}>
      <EntityManagerFileBarContent />
    </EntityFileProvider>
  );
}

const EntityManagerFileBarContent = () => {
  const { record } = useEntityManagerContext();
  const { files, totalFilesCount, isFetchingPhotos, openedFile, setIsFileEditorOpen, isFileEditorOpen, uploadNewFile } = useEntityFileContext();
  const uploadNewFileRef = useRef<HTMLInputElement>(null);

  return (
    <div className="border-b border-border p-6">
      {/* Header with Add Files button */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base text-foreground relative">
          Files
          <Badge variant="muted" size="xs" className="absolute -right-7 -top-3">
            {totalFilesCount}
          </Badge>
        </h3>

        <div className="flex items-center gap-4">
          <label className="hidden">
            <input
              ref={uploadNewFileRef}
              type="file"
              className="hidden"
              multiple
              onChange={async (e) => {
                if (e.target.files) {
                  await uploadNewFile(e.target.files);
                  e.target.value = "";
                }
              }}
              id="file-upload"
            />
          </label>

          {isFetchingPhotos && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />}
          <CompanyCamButton />
          <FileMenu />
        </div>
      </div>

      {/* Files Slider */}
      {files.length !== 0 && <FileSliderView />}

      {/* Empty state */}
      {files.length === 0 && !isFetchingPhotos && (
        <button
          className="space-y-2 flex flex-col"
          onClick={() => {
            uploadNewFileRef.current?.click();
          }}
        >
          <div className="w-24 h-24 rounded-md shrink-0 border flex justify-center items-center">
            <Upload />
          </div>
          <div className="text-xs h-4 text-muted-foreground">Add file</div>
        </button>
      )}

      {openedFile && (
        <FileDetailModal entityRecord={record} file={openedFile} open={isFileEditorOpen} setOpen={setIsFileEditorOpen} />
      )}

      {/* <FileEditor file={openedFile} open={isFileEditorOpen} setOpen={setIsFileEditorOpen} /> */}
    </div>
  );
};